var map = {
	"./Acta de Constitucion y Estatutos Waima.pdf": 1702,
	"./Certificado de Existencia y Representacion Legal.pdf": 8881,
	"./Estados Financieros Año 2021.pdf": 2290,
	"./Estatutos Originales Waima.pdf": 4292,
	"./Informe de Gestion 2021.pdf": 2629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;